export default __webpack_public_path__ + "static/media/close.4b208bbd.svg";